/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { TerminalDetails } from '../../../shared/entities/terminal';
import { getConnectivityColor, isOnline, isStandby } from '../../../utils/ConnectionStatusUtils';
import CollapseGroupItem from './CollapseGroupItem';

const ConnectivityCollapseGroupItem = ({terminal, label = 'Connection'}:
  {
    terminal: TerminalDetails | undefined,
    label?: string,
  }) => {

  const getDisplayConnectivityStatus = (connectivityStatus: string | undefined) => {
    return isOnline(connectivityStatus) ? (isStandby(connectivityStatus) ? 'Standby' : 'Active') : 'Offline';
  };

  return (
    <CollapseGroupItem
      id="connectivity"
      label={label}
      value={
        terminal &&
        getDisplayConnectivityStatus(terminal.connectivityStatus)
      }
      color={getConnectivityColor(
        (terminal || ({} as TerminalDetails)).connectivityStatus,
      )}
    />
  );
};

export default ConnectivityCollapseGroupItem;
